import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../../config.service';
import { AESService } from '../../encryption/aes.service';

@Injectable()
export class ListClassService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
    
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  listClass(): Observable<any> {
    return this.http.get(this.config.baseURL + '/code/listCode', this.httpOptions)
      .map((res) => { return res }

      );
  }
  DeleteClass(id: any): Observable<any> {
    return this.http.delete<any>(this.config.baseURL + `/code/deleteCode?id=${id}`, this.httpOptions)
      .map((res) => { return res }
      );
  }
  Updateclass(user: any): Observable<any> {
    return this.http.put<any>(this.config.baseURL + '/code/updateCode', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
}
